import { useEffect, useState } from "react";
import { GroupSteps } from "../../components/home/GroupSteps";
import { IoArrowBack } from "react-icons/io5";
import NewOrgDetails from "../../components/home/NewOrgDetails";
import SelectModules from "../../components/home/SelectModules";
import { GroupStepItemDTO } from "../../typings/uicomponents";
import NavigatebackBtn from "../../components/generic/NavigateBackBtn";
import { onGetAllmoduules } from "../../services/auth/modules";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";
import { useNavigate } from "react-router-dom";
 
export default () => {
  const Add_Steps: GroupStepItemDTO[] = [
    { title: "Company/Business", index: 0 },
    { title: "Select Modules", index: 1 },
  ];
  const { config } = useStateGetter();
  const { setallmodules, setLoading } = useStateSetter();
const navigate=useNavigate()
  const [currentstep, setcurrentstep] = useState(0);
  const [postdata, setpostdata] = useState({});

  const getmodules = async () => {
    setLoading(true);
    try {
      var res = await onGetAllmoduules(config);
      setallmodules(res.data);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }

    setLoading(false);
  };
  
  const renderStep = () => {
    switch (currentstep) {
      case 0:
        return (
          <NewOrgDetails setpostdata={setpostdata} action={setcurrentstep} />
        );
      case 1:
        return (
          <SelectModules setpostdata={setpostdata} action={setcurrentstep} />
        );
      default:
        return <NewOrgDetails action={setcurrentstep} />;
    }
  };

  useEffect(() => {
    getmodules();
    console.log(postdata);
  }, [postdata]);
  return (
    <div className="flex flex-col justify-center items-center ">
      <div className=" px-20 flex  justify-center items-center m-4">
        <NavigatebackBtn
          style={" absolute left-10"}
          onclick={() => { 
            navigate(-1)
          }}
        />
        <GroupSteps
          currentitem={currentstep}
          onItemClick={setcurrentstep}
          items={Add_Steps}
        />
      </div>

      {renderStep()}
    </div>
  );
};
